import Vue from 'vue';
import { Avatar, Pagination, Dialog, Autocomplete, Input, InputNumber, Radio, RadioGroup, RadioButton, Checkbox, CheckboxButton, CheckboxGroup, Select, Option, OptionGroup, Cascader, CascaderPanel, Button, Badge, Tag, Switch, Table, TableColumn, Form, FormItem, DatePicker, Tabs, TabPane, Icon, Row, Col, Upload, InfiniteScroll, Loading, MessageBox, Message, Tooltip, Alert, Image, Link, Descriptions, DescriptionsItem, Empty, Container, Header, Aside, Main, Footer, Skeleton, SkeletonItem, Drawer, Breadcrumb, BreadcrumbItem, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import gkForm from './gk-form.vue'
import gkTable from './gk-table.vue'

export default function () {
    Vue.prototype.$ELEMENT = { size: 'medium' };
    Vue.prototype.$loading = Loading.service;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$message = Message;

    Vue.use(Avatar);
    Vue.use(Pagination);
    Vue.use(Dialog);
    Vue.use(Autocomplete);
    Vue.use(Input);
    Vue.use(InputNumber);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(RadioButton);
    Vue.use(Checkbox);
    Vue.use(CheckboxButton);
    Vue.use(CheckboxGroup);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(OptionGroup);
    Vue.use(Cascader);
    Vue.use(CascaderPanel);
    Vue.use(Button);
    Vue.use(Badge);
    Vue.use(Tag);
    Vue.use(Switch);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(DatePicker);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Icon);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Upload);
    Vue.use(Skeleton);
    Vue.use(SkeletonItem);
    Vue.use(Image);
    Vue.use(Link);
    Vue.use(Descriptions);
    Vue.use(DescriptionsItem);
    Vue.use(Empty);
    Vue.use(Tooltip);
    Vue.use(Alert);
    Vue.use(Container);
    Vue.use(Header);
    Vue.use(Aside);
    Vue.use(Main);
    Vue.use(Footer);
    Vue.use(Drawer);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);

    Vue.use(Loading.directive);
    Vue.use(InfiniteScroll);

    Vue.component('gk-form', gkForm);
    Vue.component('gk-table', gkTable);
}